import React, { useCallback, useEffect, useRef, useState } from "react";
import AdminHeader from "./Header";
import "../../styles/Super.css";
import { useNotification } from "../../Toast/ToastProvider";
import { useNavigate, useParams } from "react-router-dom";
import {  formatShortMonthDateYear, formatShortMonthDateYearWithTime, getAdmin} from "../../include/function";
import { adminReqConfig, api } from "../../include/api";
import { ChevronDown } from "react-feather";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const PaymentDetails = () => {
  const toast = useNotification();
  const { push } = useNavigate();
  const user = getAdmin();
  const { id } = useParams();

  const [order, setOrder] = useState(null); // single order object
  const [fetchLoading, setFetchLoading] = useState(true);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [paymentDetailData, setPaymentDetailData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);

  const navigate = useNavigate();

  const [filterValues, setFilterValues] = useState({
    paymentType: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });

  const [paymentData, setPaymentData] = useState({
    amountReceived: "",
    paymentDate: "",
    paymentType: "",
    notes: "",
    refNo:"",
  });

  const handlePaymentSubmit = () => {
    if (!order) {
      toast({ type: "error", message: "Order data not available." });
      return;
    }
    if (!paymentData.amountReceived || !paymentData.paymentType) {
      toast({ type: "error", message: "Please fill in all required fields." });
      return;
    }

    const today = new Date().toISOString().split("T")[0];

    const payload = {
      orderId: order.id,
      customerId: order.customerId,
      paymentMode: paymentData.paymentType,
      amount: parseFloat(paymentData.amountReceived).toFixed(2),
      createdBy: user.name || "Admin",
      paymentStatus: "paid",
      currency: "INR",
      notes: paymentData.notes || "",
      refNo: paymentData.refNo || "",
      address: order.address || "",
      city: order.city || "",
      state: order.state || "",
      paymentDate: today,
    };

    api
      .post(`/payment/`, payload, adminReqConfig())
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast({ type: "success", message: "Payment added successfully!" });
        } else {
          toast({
            type: "error",
            message: `Payment API returned unexpected status: ${response.status}`,
          });
        }
      })
      .catch((error) => {
        const data = error.response?.data;
        toast({
          type: "error",
          message: `${data?.error}: ₹${data?.message?.remaining}`,
        });
      })
      .finally(() => {
        setPaymentData({
          amountReceived: "",
          paymentDate: "",
          paymentType: "",
          notes: "",
          refNo:"",
        });

        setIsPaymentModalOpen(false);
        getPaymentDetails()
        getOrder()
      });
  };

const checkRazorpayPayment = useCallback(() => {
  if (!id) {
    console.log("Order ID not available");
    return;
  }

  console.log("Calling checkRazorpayPayment for orderId:", id);

  api
    .post(
      "/razerpay_payment/",
      {
        action: "checkRazorpayPayment",
        orderId: id,
      },
      adminReqConfig(),
    )
    .then((response) => {
      console.log("checkRazorpayPayment response:", response.data);

      const result = response.data;

      if (result.data?.paymentStatus === "paid") {
        console.log("Payment already completed");

        // Refresh payment/order data
        getPaymentDetails();
        getOrder();
      }
    })
    .catch((error) => {
      console.error(
        "checkRazorpayPayment error:",
        error.response?.data || error,
      );
    });
}, [id]);

  useEffect(() => {
    if (id) {
      checkRazorpayPayment();
    }
  }, [id, checkRazorpayPayment]);

  const getOrder = useCallback(() => {
    setFetchLoading(true);
    api
      .get(`/orders/?id=${id}`, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const paymentDetailData = response.data.data[0] || null;
          setOrder(paymentDetailData);
          if (paymentDetailData?.customerId) {
            getCustomerDetail(paymentDetailData?.customerId);
          }
        }
      })
      .catch((error) => {
        toast({ type: "error", message: "Failed to load order." });
        push("/admin/sales/orders");
      })
      .finally(() => {
        setFetchLoading(false);
      });
  }, [id, user.id, push, toast]);

  const getCustomerDetail = useCallback((customerId) => {
    if (!customerId) return;
    setFetchLoading(true);
    api
      .get(`/customer/?id=${customerId}`, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setCustomerDetail(response.data.data[0] || null);
        }
      })
      .catch((error) => {
        toast({ type: "error", message: "Failed to load customer detail." });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  }, []);

  const getPaymentDetails = (filters = {}) => {
    setFetchLoading(true);
     const params = new URLSearchParams();
    if (id) {
   params.set("orderId", id); 
    }
     if (filters.fromDate) params.set("fromDate", filters.fromDate);
     if (filters.toDate) params.set("toDate", filters.toDate);
     if (filters.paymentMethod) params.set("paymentMethod", filters.paymentMethod);
     // ... other filters

     const url = `/payment/?${params.toString()}`;

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // Sort by date in descending order (newest first)
          const sortedData = response.data.data.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA; // Descending order
          });
          setPaymentDetailData(sortedData);
          setFilteredData(sortedData);
        } else {
          setPaymentDetailData([]);
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch invoice:", error);
        setPaymentDetailData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

   const handlePaymentDetailClick = (customerId) => {
     navigate(`/admin/customer/customerDetails/${customerId}`);
   };

  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };

    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";

      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }

      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }

    // Clear the old `date` filter if using range
    if (finalFilters.timePeriod) {
      finalFilters.date = ""; // because backend uses either `date` OR `fromDate/toDate`
    }

    getPaymentDetails(finalFilters);
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    const empty = {
    paymentType: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
    };
    setFilterValues(empty);
    getPaymentDetails();
    setIsFilterPanelOpen(false);

    // getPaymentDetails(filterValues); 
    // setIsFilterPanelOpen(false);
  };

  //Search
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredData(paymentDetailData); // show all invoices again
    } else {
      const filtered = paymentDetailData.filter(
        (order) =>
          order.paymentMethod?.toLowerCase().includes(searchQuery.toLowerCase()) 
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, paymentDetailData]);

  // Then in useEffect:
  useEffect(() => {
     if (id) {
       getOrder();
       getPaymentDetails(); 
     }
  }, []);

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
          setIsFilterPanelOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isFilterPanelOpen]);
  


  //Dropdown options
  const PAYMENT_OPTIONS = [
    { value: "paid", label: "Paid" },
    { value: "pending", label: "Unpaid" },
    { value: "partially paid", label: "Partially Paid" },
  ];

  const APPROVAL_OPTIONS = [
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];

  const STATUS_OPTIONS = [
    { value: "ordered", label: "Recieved" },
    { value: "confirmed", label: "Confirmed" },
    { value: "packed", label: "Packed" },
    { value: "shipped", label: "Shipped" },
    { value: "delivered", label: "Delivered" },
    { value: "return", label: "Return" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const totalQuantity = order?.orderItems?.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0
  );

  const formatOrderId = (order) => {
    if (!order?.createTimestamp || !order?.id) return "ORD--";

    // Extract last 2 digits of year
    const year = new Date(order.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `ORD${yy}-${paddedId}`;
  };

  const formatTransactionId = ( payment) => {
    if (!payment?.createdTimestamp || !payment?.id) return "TRN--";

    // Year YY
    const year = new Date(payment.createdTimestamp).getFullYear();
    const yy = String(year).slice(-2);

    // Order Id padded
    const paddedOrderId = String(payment.orderId).padStart(4, "0");

    // Payment transaction ID padded
    const paddedTrnId = String(payment.id).padStart(4, "0");

    return `TRN${yy}/INV${yy}-${paddedOrderId}-${paddedTrnId}`;
  };
  const getDaysCrossed = (timestamp) => {
    if (!timestamp) return 0;

    const orderDate = new Date(timestamp);
    const now = new Date();

    const diffTime = now.getTime() - orderDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= 0 ? diffDays : 0;
  };

 const handleDownloadCSV = () => {
   const dataToExport =
     selectedData.length > 0
       ? paymentDetailData.filter((payment) =>
           selectedData.includes(payment.id)
         )
       : paymentDetailData;

   if (dataToExport.length === 0) {
     toast({ type: "error", message: "No payment data to download" });
     return;
   }

   const csvRows = dataToExport.map((payment, index) => {
     const amount = parseFloat(payment.amount) || 0;

     return {
       "S.No": index + 1,
       "Payment ID": payment.id || "-",
       "Order ID": payment.orderId || "-",
       "Customer Name": payment.name || "-",
       "Customer Type": payment.customerType || "-",
       "Payment Date": payment.createdTimestamp
         ? new Date(payment.createdTimestamp).toLocaleString("en-IN")
         : "-",
       "Payment Mode": payment.paymentMode || "-",
       "Payment Status": payment.paymentStatus || "-",
       "Amount": amount.toLocaleString("en-IN"),
       Notes: payment.notes || "-",

     


     };
   });

   const columns = [
     "S.No",
     "Payment ID",
     "Order ID",
     "Customer Name",
     "Customer Type",
     "Payment Date",
     "Payment Mode",
     "Payment Status",
     "Amount",
     "Notes",
 
   ];

   const csv = Papa.unparse({
     fields: columns,
     data: csvRows,
   });

   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
   const url = URL.createObjectURL(blob);
   const link = document.createElement("a");
   link.href = url;
   link.setAttribute("download", "Transaction_history.csv");
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
 };

 const handleDownloadPDF = () => {
  const dataToExport = selectedData.length > 0
    ? paymentDetailData.filter(p => selectedData.includes(p.id))
    : paymentDetailData;

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No payment data to export as PDF" });
    return;
  }

  // Generate one PDF per selected payment
  dataToExport.forEach((payment) => {
    generatePaymentPDF(payment);
  });

  toast({
    type: "success",
    message: `PDF(s) generated for ${dataToExport.length} payment(s)`,
  });
};

  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = paymentDetailData.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = paymentDetailData.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const generatePaymentPDF = (payment) => {
    const doc = new jsPDF();
    const titleY = 20;

    doc.setFontSize(16);
    doc.text(`Payment Receipt`, 14, titleY);
    doc.setFontSize(10);

    const formatDate = (timestamp) => {
      if (!timestamp) return "-";
      const d = new Date(timestamp);
      return isNaN(d.getTime()) ? "-" : d.toLocaleString("en-IN");
    };

    const tableData = [
      ["Field", "Value"],
      ["Payment ID", `#${payment.id}`],
      ["Order ID", payment.orderId || "-"],
      ["Customer Name", payment.name || "-"],
      ["Customer Type", payment.customerType || "-"],
      ["Amount", `₹${parseFloat(payment.amount || 0).toFixed(2)}`],
      ["Payment Mode", payment.paymentMode || "-"],
      ["Payment Status", payment.paymentStatus || "-"],
      ["Date & Time", formatDate(payment.createdTimestamp)],
      ["Notes", payment.notes || "-"],
    ];

    autoTable(doc, {
      startY: titleY + 10,
      head: [tableData[0]],
      body: tableData.slice(1),
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 2 },
      headStyles: { fillColor: [43, 149, 211] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 60 },
        1: { cellWidth: 120 },
      },
      margin: { left: 14, right: 14 },
    });

    const timestamp = `Generated on: ${new Date().toLocaleString("en-IN")}`;
    const finalY = doc.previousAutoTable?.finalY + 10 || titleY + 40;
    if (finalY > 280) doc.addPage();
    doc.text(timestamp, 14, Math.min(finalY, 280));

    const safeName = (payment.name || "payment").replace(/\s+/g, "_");
    doc.save(`Payment_${payment.id}_${safeName}.pdf`);
  };

  // Total Paid Amount
const totalPaidAmount =
  paymentDetailData?.reduce(
    (total, item) => total + Number(item.amount || 0),
    0
  ) || 0;

  return (
    <AdminHeader title="PAYMENT DETAILS">
      <div className="content-wrapper p-0">
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {/* Middle Row: Customer Info + Address + Date */}
          <div className="row g-3 mb-10">
            <div className="col-8">
              <div
                className="order-detail-card shadow-sm"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <div
                  className=" mb-3"
                  style={{
                    backgroundColor: "#fff",
                    display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    // flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <h6
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        color: "#2c3e50",
                        margin: 0,
                      }}
                    >
                      Order ID{" "}
                      <span style={{ color: "#9da6b5" }}>
                        {formatOrderId(order)}
                      </span>
                    </h6>
                  </div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <CustomColoredDropdown
                      value={order?.orderItems[0]?.status}
                      options={STATUS_OPTIONS}
                      type="status"
                      disable={true}
                    />
                    <CustomColoredDropdown
                      value={order?.paymentStatus}
                      options={PAYMENT_OPTIONS}
                      type="payment"
                      disable={true}
                    />
                  </div>
                  <div
                    style={{ display: "flex", gap: "10px", marginLeft: "auto" }}
                  >
                    <button
                      onClick={() => setIsPaymentModalOpen(true)}
                      style={{
                        color: "#fff",
                        backgroundColor: "#2b95d3",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: "700",
                        cursor: "pointer",
                        padding: "8px 16px",
                        minWidth: "150px",
                        height: "40px",
                        border: "none",
                        textWrap: "nowrap",
                      }}
                      fetchLoading={"loading..."}
                    >
                      Add Payment
                    </button>
                  </div>
                </div>
                <div className="row g-4 mt-14">
                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>Customer Name</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {order?.name || "Riyas Ahamed"}
                      </p>
                    </div>

                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Billing Address</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#6E7C94",
                          lineHeight: "1.4",
                        }}
                      >
                        {order?.billAddress ||
                        order?.billLandmark ||
                        order?.billLocality ||
                        order?.billCity ||
                        order?.billState ||
                        order?.billPin ? (
                          <>
                            {order?.billAddress && `${order?.billAddress}, `}
                            {order?.billLandmark && `${order?.billLandmark}, `}
                            {order?.billLocality && `${order?.billLocality}, `}
                            {order?.billCity && `${order?.billCity}, `}
                            <br />
                            {order?.billState && `${order?.billState}-`}
                            {order?.billPin}
                          </>
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>Ordered Date & Time</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {formatShortMonthDateYearWithTime(
                          order?.createTimestamp,
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="col-3">
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      <strong>Payment Type</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {order?.orderItems?.[0].paymentMode || "N/A"}
                      </p>
                    </div>

                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Delivery Address</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#6E7C94",
                          lineHeight: "1.4",
                        }}
                      >
                        {order?.address},{order?.landmark},{order?.locality},
                        {order?.city},<br />
                        {order?.state}-{order?.pin}
                      </p>
                    </div>
                  </div>

                  <div className="col-3">
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      <strong>Billing Name</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {order?.billName || "N/A"}
                      </p>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Billing GST Number</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {order?.billGst || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-4">
              <div
                className="order-detail-card shadow-sm mb-3"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      color: "#2c3e50",
                      margin: 0,
                    }}
                  >
                    Total Amount
                  </h6>
                </div>
                <p
                  style={{
                    background: "#d9ebff",
                    padding: "10px",
                    borderRadius: "5px",
                    fontWeight: "600",
                    color: "#6E7C95",
                    margin: 0,
                  }}
                >
                  ₹{" "}
                  {Number(order?.billAmount || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>

              <div
                className="order-detail-card shadow-sm"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "20px",
                  marginTop: "24px",
                }}
              >
                <h6
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    color: "#2c3e50",
                    marginBottom: "18px",
                  }}
                >
                  Total Quantity
                </h6>
                <p
                  style={{
                    background: "#d9ebff",
                    padding: "10px",
                    borderRadius: "5px",
                    fontWeight: "600",
                    color: "#6E7C95",
                    margin: 0,
                  }}
                >
                  {totalQuantity}
                </p>
              </div>
            </div>
          </div>

          {/* Customer Details */}
          <div className="row g-3 mb-3 ">
            <div className="col-8">
              <div
                className="order-detail-card shadow-sm"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <h6
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      color: "#2c3e50",
                      margin: 0,
                    }}
                  >
                    Customer Details
                  </h6>
                </div>
                <div className="row g-4 mt-14">
                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>Customer Name</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail?.name || "N/A"}
                      </p>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Phone Number</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail?.phoneNumber || "N/A"}
                      </p>
                    </div>
                  </div>

                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>Customer Type</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail.customerType
                          ? `${customerDetail.customerType} (${
                              customerDetail.customerType === "individual"
                                ? "B2C"
                                : "B2B"
                            })`
                          : "N/A"}{" "}
                      </p>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Email ID</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail?.emailId || "N/A"}
                      </p>
                    </div>
                  </div>

                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>Company Name</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail?.shopName || "N/A"}
                      </p>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        marginTop: "30px",
                      }}
                    >
                      <strong>Address</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#6E7C94",
                          lineHeight: "1.4",
                        }}
                      >
                        {customerDetail?.address1 || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="col-3">
                    <div style={{ fontSize: "14px", color: "black" }}>
                      <strong>GST Number</strong>
                      <p
                        style={{
                          margin: "4px 0",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#6E7C94",
                        }}
                      >
                        {customerDetail?.proof?.[0]?.gstNo || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {order?.orderItems[0]?.paymentMode === "credit" ? (
              <div className="col-4">
                <div
                  className="order-detail-card shadow-sm mb-3"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "20px",
                  }}
                >
                  {/* Credit Balance */}
                  <div className="">
                    <h6
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        color: "#2c3e50",
                        marginBottom: "12px",
                      }}
                    >
                      Credit Balance
                    </h6>
                    {order?.paymentStatus === "paid" ? (
                      <>
                        <div
                          style={{
                            height: "12px",
                            backgroundColor: "#e0e0e0",
                            borderRadius: "4px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <div
                            style={{
                              width: "0%",
                              height: "100%",
                              backgroundColor: "#3498db",
                              borderRadius: "4px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#6E7C94",
                              fontWeight: "500",
                            }}
                          >
                            ₹0
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#6E7C94",
                              fontWeight: "500",
                            }}
                          >
                            out of ₹{customerDetail.creditBal?.toLocaleString()}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        {(() => {
                          const currentCredit =
                            Number(customerDetail?.currentCredit) || 0;
                          const creditBal =
                            Number(customerDetail?.creditBal) || 0;
                          const isOverLimit = currentCredit > creditBal;

                          return (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  marginBottom: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    height: "12px",
                                    backgroundColor: "#e0e0e0",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${Math.min(
                                        (currentCredit / creditBal) * 100,
                                        100,
                                      )}%`,
                                      height: "100%",
                                      backgroundColor: isOverLimit
                                        ? "#D32B2E"
                                        : "#3498db",
                                      borderRadius: "4px",
                                    }}
                                  ></div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: isOverLimit ? "#D32B2E" : "#6E7C94",
                                    fontWeight: "500",
                                  }}
                                >
                                  ₹{currentCredit.toLocaleString()}{" "}
                                  {isOverLimit && "Exceeds limit"}
                                </span>
                                {!isOverLimit ? (
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#6E7C94",
                                      fontWeight: "500",
                                    }}
                                  >
                                    out of ₹{creditBal.toLocaleString()}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </>
                          );
                        })()}
                      </>
                    )}
                  </div>
                  {/* Credit Limit (In Days) */}
                  <div className="mt-24 mb-12">
                    <h6
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        color: "#2c3e50",
                        marginBottom: "12px",
                      }}
                    >
                      Credit Limit (In Days)
                    </h6>

                    {(() => {
                      // Compute shared values once
                      const creditLimitDays =
                        Number(customerDetail?.creditLimit) || 10;

                      if (order?.paymentStatus === "paid") {
                        return (
                          <>
                            <div
                              style={{
                                height: "12px",
                                backgroundColor: "#e0e0e0",
                                borderRadius: "4px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <div
                                style={{
                                  width: "0%",
                                  height: "100%",
                                  backgroundColor: "#3498db",
                                  borderRadius: "4px",
                                }}
                              ></div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#6E7C94",
                                  fontWeight: "500",
                                }}
                              >
                                0 days
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#6E7C94",
                                  fontWeight: "500",
                                }}
                              >
                                out of {creditLimitDays} days
                              </span>
                            </div>
                          </>
                        );
                      } else {
                        const daysCrossed = getDaysCrossed(
                          customerDetail?.creditDate,
                        );
                        const isOverLimit = daysCrossed > creditLimitDays;

                        return (
                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginBottom: "8px",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  height: "12px",
                                  backgroundColor: "#e0e0e0",
                                  borderRadius: "4px",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    width: `${Math.min(
                                      (daysCrossed / creditLimitDays) * 100,
                                      100,
                                    )}%`,
                                    height: "100%",
                                    backgroundColor: isOverLimit
                                      ? "#D32B2E"
                                      : "#3498db",
                                    borderRadius: "4px",
                                  }}
                                ></div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: isOverLimit ? "#D32B2E" : "#6E7C94",
                                  fontWeight: "500",
                                }}
                              >
                                {daysCrossed} days{" "}
                                {isOverLimit && "(Exceeds limit)"}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#6E7C94",
                                  fontWeight: "500",
                                }}
                              >
                                out of {creditLimitDays} days
                              </span>
                            </div>
                          </>
                        );
                      }
                    })()}
                  </div>

                  {/* Footer message: show if either balance or days are exceeded */}
                  {(() => {
                    const currentCredit =
                      Number(customerDetail?.currentCredit) || 0;
                    const creditBal = Number(customerDetail?.creditBal) || 0;
                    const daysCrossed = getDaysCrossed(
                      customerDetail?.creditDate,
                    );
                    const creditLimitDays =
                      Number(customerDetail?.creditLimit) || 10;
                    const isOverBalance = currentCredit > creditBal;
                    const isOverDays = daysCrossed > creditLimitDays;

                    if (
                      order?.paymentStatus !== "paid" &&
                      (isOverBalance || isOverDays)
                    ) {
                      return (
                        <p
                          style={{
                            marginTop: "16px",
                            fontSize: "13px",
                            color: "#6E7C94",
                            fontWeight: "",
                          }}
                        >
                          Limit will reset after total outstanding is cleared.
                        </p>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            ) : (
              <div className="col-md-4"></div>
            )}
          </div>

          <div className="row g-3 ">
            <div className="col-md-8">
              <div className="rounded-5 bg-white py-24">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-md-2">
                    <h6 className="fs-6 mb-0">Payment History</h6>
                  </div>
                  <div className="col-md-7">
                    <div className="d-flex align-items-center">
                      <div
                        className="nav-item w-100"
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #c6d6f5",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <img
                            src="/assets/images/search-icon.png"
                            style={{ width: "18px", marginLeft: "8px" }}
                          />
                          <input
                            type="text"
                            placeholder="Filter and search here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                              border: "none",
                              outline: "none",
                              padding: "8px",
                              width: "100%",
                              fontSize: "14px",
                              backgroundColor: "transparent",
                            }}
                            onClick={() => {
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                          <ChevronDown
                            size={16}
                            style={{
                              marginRight: "8px",
                              cursor: "pointer",
                              transform: isFilterPanelOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "0.2s",
                            }}
                            onClick={() => {
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                        </div>

                        {isFilterPanelOpen && (
                          <FilterPanel
                            filterValues={filterValues}
                            onFilterChange={(key, value) =>
                              setFilterValues((prev) => ({
                                ...prev,
                                [key]: value,
                              }))
                            }
                            onApply={applyFilters}
                            onClear={clearFilters}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 text-end">
                    <CustomDropdown
                      handleDownloadCSV={handleDownloadCSV}
                      handleDownloadPDF={handleDownloadPDF}
                    />
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead>
                      <tr>
                        <th scope="col">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              paymentDetailData.length > 0 &&
                              paymentDetailData.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>

                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Transaction ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          razorpayOrder Id
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          razorpayPayment Id
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Payment Method
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Date & time
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Reference.No
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Amt.Recieved
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentDetailData.length > 0 ? (
                        paymentDetailData.map((payment) => {
                          return (
                            <React.Fragment key={payment.id}>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    style={{ borderColor: "#c5d5f5" }}
                                    className="form-check-input"
                                    checked={selectedData.includes(payment.id)}
                                    onChange={() => handleSelectOne(payment.id)}
                                  />
                                </td>

                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      textWrap: "nowrap",
                                    }}
                                  ></div>
                                  {formatTransactionId(payment)}
                                </td>
                                <td>{payment.razorpayOrderId}</td>
                                <td>{payment.razorpayPaymentId}</td>
                                <td>{payment.paymentMode}</td>
                                <td>
                                  {formatShortMonthDateYearWithTime(
                                    payment.createdTimestamp,
                                  )}
                                </td>
                                <td>{payment.refNo || "N/A"}</td>
                                <td>
                                  <CustomColoredDropdown
                                    value={payment.paymentStatus}
                                    options={PAYMENT_OPTIONS}
                                    type="payment"
                                    disable={true}
                                  />
                                </td>
                                <td>{payment.amount}</td>
                              </tr>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center py-3">
                            No Transaction found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* Table Footer (Summary Rows) */}
                    {paymentDetailData.length > 0 ? (
                      <tfoot>
                        <tr>
                          <td
                            colSpan="6"
                            className="custom-striped-table-product-list-tfoot-td"
                          >
                            <span style={{ color: "black", fontWeight: "600" }}>
                              Total Bill Amount
                            </span>
                          </td>
                          <td
                            style={{
                              paddingTop: "14px",
                              paddingBottom: "14px",
                              paddingLeft: "16px",
                              paddingRight: "16px",
                              fontWeight: "600",
                              color: "#808ca2",
                              textAlign: "right",
                            }}
                          >
                            {" "}
                            ₹
                            {Number(order?.billAmount || 0).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                              },
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan="6"
                            className="custom-striped-table-product-list-tfoot-td"
                            style={{ background: "#fff" }}
                          >
                            <span style={{ color: "black", fontWeight: "600" }}>
                              Total Paid Amount
                            </span>
                          </td>
                          <td
                            style={{
                              paddingTop: "14px",
                              paddingBottom: "14px",
                              paddingLeft: "16px",
                              paddingRight: "16px",
                              fontWeight: "600",
                              color: "#808ca2",
                              background: "#fff",
                              textAlign: "right",
                            }}
                          >
                            ₹
                            {Number(totalPaidAmount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </td>
                        </tr>
                        <tr
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          <td
                            colSpan="6"
                            className="custom-striped-table-product-list-tfoot-td"
                          >
                            <span style={{ color: "black", fontWeight: "600" }}>
                              Balance
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "right",
                            }}
                          >
                            ₹
                            {Number(
                              order?.billAmount - totalPaidAmount,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </td>
                        </tr>
                      </tfoot>
                    ) : (
                      <div></div>
                    )}
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="order-detail-card shadow-sm mb-3"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      color: "#2c3e50",
                      margin: 0,
                    }}
                  >
                    Total Outstanding amount
                  </h6>
                </div>
                <p
                  style={{
                    background: "#d9ebff",
                    padding: "10px",
                    borderRadius: "5px",
                    fontWeight: "600",
                    color: "#6E7C95",
                    margin: 0,
                  }}
                >
                  ₹
                  {Number(order?.billAmount - totalPaidAmount).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                    },
                  )}
                </p>
                <div>
                  <button
                    onClick={() => handlePaymentDetailClick(order.customerId)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#006fbf",
                      // textDecoration: "underline",
                      cursor: "pointer",
                      padding: 0,
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginTop: "30px",
                    }}
                    title="View Payment Details"
                  >
                    View Full Transaction History
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {isPaymentModalOpen && (
        <PaymentModal
          isOpen={isPaymentModalOpen}
          onClose={() => setIsPaymentModalOpen(false)}
          onSubmit={handlePaymentSubmit}
          paymentData={paymentData}
          setPaymentData={setPaymentData}
        />
      )}
    </AdminHeader>
  );
};

export default PaymentDetails;

const CustomColoredDropdown = ({
  value,
  onChange,
  options,
  type = "payment",
  disable = false,
  loading=false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
const getColors = (status) => {
    if (type === "approval") {
      switch (status) {
        case "approved":
          return {
            color: "#065F46",
            bg: "#D1FAE5",
            border: `1px solid #065F46`,
          };
        case "rejected":
          return {
            color: "#991B1B",
            bg: "#FEE2E2",
            border: `1px solid #991B1B`,
          };
        default:
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
      }
    }
    if (type === "payment") {
      switch (status) {
        case "paid":
          return { color: "white", bg: "#26DD8E", border: `1px solid #26DD8E` };
        case "pending":
          return { color: "white", bg: "#F8556D", border: `1px solid #F8556D` };
        case "partially-paid":
          return {
            color: "white",
            bg: "#D19A04",
            border: `1px solid #D19A04`,
          };
        default:
          return { color: "black", bg: "#fff", border: `1px solid #ccc` };
      }
    } else {
      switch (status) {
        case "delivered":
          return { color: "#46A27B", bg: "#D5F5E7", border: "none" };
        case "shipped":
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
        case "packed":
          return { color: "#AC29AC", bg: "#FFCEFF", border: "none" };
        case "ordered":
          return { color: "#66B2E2", bg: "#D9EBFF", border: "none" };
        case "cancelled":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        case "return":
          return { color: "#8977C3", bg: "#DDD5F5", border: "none" };
        case "confirmed":
          return { color: "#39AFA7", bg: "#BFEFEC", border: "none" };
        case "rejected":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        default:
          return { color: "black", bg: "#f5f5f5", border: "none" };
      }
    }
  };
  const { color, bg, border } = getColors(value);
  const displayLabel =
    options.find((opt) => opt.value === value)?.label ||
    (value
      ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      : value);

  // Only allow interaction if NOT disabled
  const handleToggle = () => {
    if (!disable) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (val) => {
    if (!disable) {
      onChange?.(val);
      setIsOpen(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        fontSize: "14px",
      }}
    >
      {/* Main Button */}
      <div
        onClick={handleToggle}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 12px",
          border: border,
          borderRadius: "6px",
          backgroundColor: bg,
          cursor: disable || loading ? "not-allowed" : "pointer",
          fontWeight: "500",
          color: color,
          minWidth: "120px",
          opacity: disable || loading ? 0.7 : 1,
          pointerEvents: disable || loading ? "none" : "auto",
        }}
      >
        {loading ? (
          <span>Updating....</span>
        ) : (
          <>
            <span>{displayLabel}</span>
            {!disable && (
              <ChevronDown size={14} style={{ color, marginLeft: "6px" }} />
            )}
          </>
        )}
      </div>

      {/* Dropdown Menu — only show if enabled and open */}
      {!disable && isOpen && (
        <>
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              listStyle: "none",
              margin: 0,
              padding: 0,
              backgroundColor: "#fff",
              border: border === "none" ? "none" : border,
              borderRadius: "6px",
              zIndex: 1000,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {options.map((opt) => {
              const optColors = getColors(opt.value);
              return (
                <li
                  key={opt.value}
                  onClick={() => handleOptionClick(opt.value)}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    color: optColors.color,
                    backgroundColor: optColors.bg,
                    fontWeight: "500",
                    border: "none",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f0f0f0")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = optColors.bg)
                  }
                >
                  {opt.label}
                </li>
              );
            })}
          </ul>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
            }}
            onClick={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
};

const PaymentModal = ({
  isOpen,
  onClose,
  onSubmit,
  paymentData,
  setPaymentData,
}) => {
  if (!isOpen) return null;

  // Calculate today's date in YYYY-MM-DD format for the input
  const today = new Date().toISOString().split("T")[0];

  const PAYMENT_TYPE_OPTIONS = [
    { value: "cash", label: "Cash" },
    { value: "cheque", label: "Cheque" },
    { value: "credit-card", label: "Credit Card" },
    { value: "debit-card", label: "Debit Card" },
    { value: "net-banking", label: "Net Banking" },
    { value: "upi", label: "UPI" },
    { value: "neft", label: "NEFT" },
    { value: "rtgs", label: "RTGS" },
  ];

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "24px",
          width: "900px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            width: "32px",
            height: "32px",
            background: "none",
            border: "3px solid #ddd",
            borderRadius: "50%",
            fontSize: "28px",
            cursor: "pointer",
            color: "#6E7C94",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          &times;
        </button>
        <h6
          style={{ marginBottom: "20px", fontWeight: "700", fontSize: "20px" }}
        >
          Add Payment 

        </h6>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
          }}
        >
          <div>
            <label
              htmlFor="amountReceived"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Amount Received
            </label>
            <input
              id="amountReceived"
              type="number"
              step="0.01" 
              placeholder="Enter the amount"
              value={paymentData.amountReceived}
              onChange={(e) =>
                setPaymentData({
                  ...paymentData,
                  amountReceived: e.target.value,
                })
              }
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
              }}
              required
            />
          </div>
          <div>
            <label
              htmlFor="paymentDate"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Payment Date
            </label>
            <input
              id="paymentDate"
              type="text" 
              value={today} 
              readOnly 
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                backgroundColor:
                  "#f8f9fa" ,
              }}
            />
          </div>
          <div>
            <label
              htmlFor="paymentType"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Payment Type
            </label>
            <select
              id="paymentType"
              value={paymentData.paymentType}
              onChange={(e) =>
                setPaymentData({ ...paymentData, paymentType: e.target.value })
              }
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
              }}
              required
            >
              <option value="">Select</option>
              {PAYMENT_TYPE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              htmlFor="notes"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Reference No
            </label>
            <input
              id="refNo"
              type="text"
              placeholder="Enter reference no"
              value={paymentData.refNo}
              onChange={(e) =>
                setPaymentData({ ...paymentData, refNo: e.target.value })
              }
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
              }}
            />
          </div>
          <div>
            <label
              htmlFor="notes"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Notes
            </label>
            <input
              id="notes"
              type="text"
              placeholder="Write notes here..."
              value={paymentData.notes}
              onChange={(e) =>
                setPaymentData({ ...paymentData, notes: e.target.value })
              }
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
              }}
            />
          </div>
        </div>
        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onSubmit} // Now calls the updated API handler with the item
            style={{
              width: "150px", // Added same fixed width as Clear All
              padding: "8px 16px",
              borderRadius: "6px",
              backgroundColor: "#2b95d3",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              border: "none",
            }}
          >
            Add
          </button>
          <button
            onClick={onClose}
            style={{
              width: "150px", // Added fixed width
              padding: "8px 16px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#D9EBFF",
              color: "#3B9DD7",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};

//Filter Panel Component
const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.timePeriod}
            onChange={(e) => onFilterChange("timePeriod", e.target.value)}
          >
            <option value="">Time Period</option>
            <option value="all">All Time</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="thisMonth">This Month</option>
            <option value="last3Months">Last 3 Months</option>
            <option value="thisYear">This Year</option>
            <option value="period"> Period</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.paymentMethod}
            onChange={(e) => onFilterChange("paymentMethod", e.target.value)}
          >
            <option value="">Payment Type</option>
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="credit-card">Credit Card</option>
            <option value="debit-card">Debit Card</option>
            <option value="net-banking">Net Banking</option>
            <option value="upi">UPI</option>
            <option value="neft">NEFT</option>
            <option value="rtgs">RTGS</option>
          </select>
        </div>
        {/* Conditional: Show fromDate & toDate only when "period" is selected */}
        {filterValues.timePeriod === "period" && (
          <>
            <div className="col-md-6">
              <input
                type={filterValues.fromDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="From Date"
                value={filterValues.fromDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.fromDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("fromDate", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <input
                type={filterValues.toDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="To Date"
                value={filterValues.toDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.toDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("toDate", e.target.value)}
              />
            </div>
          </>
        )}

        {/* <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.paymentStatus}
            onChange={(e) => onFilterChange("paymentStatus", e.target.value)}
          >
            <option value="">Payment Status</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="partially paid">Partially Paid</option>
          </select>
        </div> */}

      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};

const CustomDropdown = ({ handleDownloadCSV,handleDownloadPDF }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Download Excel", value: "export" },
    { label: "Download PDF", value: "pdf" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      handleDownloadCSV();
    } else if (opt.value === "pdf") {
      handleDownloadPDF();
    }
    setSelected("Options");
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};